export class BalanceRoutes
{
	static Home = '/';
	static Login = '/login';
	// summary
	static SummaryList(asset_id: string)
	{
		return `/summary/${asset_id}/list`;
	};
	static SummaryView(id: string)
	{
		return `/summary/${id}/view`;
	}
	// transaction
	static TransactionList(asset_id: string)
	{
		return `/transaction/${asset_id}/list`;
	};
	static TransactionView(id: string)
	{
		return `/transaction/${id}/view`;
	}
}